import { getMobietrainApiUrl } from './config';

// Legacy media is served by mobietrain-api under root-relative paths; `<img>` requests are
// authorised by the partitioned (CHIPS) cookie set during the token exchange (see `token.ts`).
export const resolveMobietrainMediaUrl = (relativePath: string | null | undefined): string => {
  if (!relativePath) {
    return '';
  }
  if (/^https?:\/\//i.test(relativePath)) {
    return relativePath;
  }
  // The API returns root-relative paths (e.g. /media/...); the /api base prefixes them as
  // the deployed ingress requires, and the local dev proxy strips it again.
  const path = relativePath.startsWith('/') ? relativePath : `/${relativePath}`;
  return `${getMobietrainApiUrl()}${path}`;
};
